/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_App_Collapse_SidebarInputs */

const en_nav_app_collapse_sidebar = /** @type {(inputs: Nav_App_Collapse_SidebarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collapse sidebar`)
};

const es_nav_app_collapse_sidebar = /** @type {(inputs: Nav_App_Collapse_SidebarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contraer barra lateral`)
};

/**
* | output |
* | --- |
* | "Collapse sidebar" |
*
* @param {Nav_App_Collapse_SidebarInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_app_collapse_sidebar = /** @type {((inputs?: Nav_App_Collapse_SidebarInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_App_Collapse_SidebarInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_app_collapse_sidebar(inputs)
	return en_nav_app_collapse_sidebar(inputs)
});